import { useGroupsResourceStatusSubscriber, useGroupsSubscriber } from '../../services/store';

// Splitting out group list data from resource as group list changes are volatile
export const useGroupsResourceStatus = () => useGroupsResourceStatusSubscriber()[0];

const useGroupList = () => useGroupsSubscriber()[0];

export default useGroupList;
